import { render, staticRenderFns } from "./CasosSoporte.vue?vue&type=template&id=5fc7b26c"
import script from "./CasosSoporte.vue?vue&type=script&lang=js"
export * from "./CasosSoporte.vue?vue&type=script&lang=js"
import style0 from "./CasosSoporte.vue?vue&type=style&index=0&id=5fc7b26c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports